export const birthdayConfig = {
  name: 'Henry',
  age: 7,
  date: 'DATUM FOLGT',
  time: 'UHRZEIT FOLGT',
  location: 'ORT FOLGT',
  message: 'Gemeinsam spielen, feiern und Spaß haben!'
} as const;
